module.exports = __webpack_public_path__ + "img/jlxny.834a7bed.png";